import { CSVEntity, CustomFieldClassType } from 'shared'
import CIMSTable from 'components/CIMSTable'
import IssueTrackerProvider, {
  useIssueTrackerContext,
} from './IssueTrackerContext'
import ActionModal from './components/ActionModal'
import DraftSubmitModal from './components/DraftSubmitModal'
import { useColumns } from './hooks/useColumns'
import { useCreate } from './hooks/useCreate'
import { useExpand } from './hooks/useExpand'
import { usePayItems } from './hooks/usePayItems'
import { WithPayItemGlobalId } from 'components/CIMSTable/components/HeaderActionButtons/types'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import { useRemove } from './hooks/useRemove'
import { useRestore } from './hooks/useRestore'
import { useCustom } from './hooks/useCustom'
import RevertModal from './components/RevertModal'
import { useEdit } from './hooks/useEdit'
import IssueReportsSelectOptionsProvider from '../../IssueReportsSelectOptionsContext'

const InnerIssueTracker: React.FC = () => {
  const { issues, relations, payItemGlobalId } = useIssueTrackerContext()
  return (
    <CIMSTable
      records={issues.issues}
      loading={issues.loading}
      rowKey="id"
      columns={useColumns()}
      expand={useExpand()}
      actions={{
        header: {
          create: useCreate(),
          csv: !!payItemGlobalId ? undefined : CSVEntity.Issue,
          deepLinkKey: 'id',
          onReload: () => {
            relations.refetch()
            issues.refetch()
          },
          payItems: usePayItems(),
        },
        row: {
          custom: useCustom(),
          edit: useEdit(),
          remove: useRemove(),
          restore: useRestore(),
        },
      }}
    >
      <RevertModal />
      <DraftSubmitModal />
      <ActionModal />
    </CIMSTable>
  )
}

const IssueTracker: React.FC<WithPayItemGlobalId> = ({ payItemGlobalId }) => {
  return (
    <IssueReportsSelectOptionsProvider>
      <ProjectCustomFieldsProvider classType={CustomFieldClassType.Issue}>
        <PayItemSelectProvider>
          <IssueTrackerProvider payItemGlobalId={payItemGlobalId}>
            <InnerIssueTracker />
          </IssueTrackerProvider>
        </PayItemSelectProvider>
      </ProjectCustomFieldsProvider>
    </IssueReportsSelectOptionsProvider>
  )
}

export default IssueTracker
